<div id="contactusPage">
  <div class="contactus-container">
    <app-contact-form></app-contact-form>
    <div class="contact-card-wrapper">
      <app-card *ngFor="let card of contactCards | keyvalue" [title]="card.value.contactType" [img]="card.value.img"
        [isImgTop]="true" (click)="onCardClick($event, card.value.actionType)">
      </app-card>
    </div>
  </div>
</div>